export default __webpack_public_path__ + "static/v_logo-c905b1b6629041dd307fa9d65addd847.svg";